import { Box, Button, Card, CardContent, CardHeader, List, ListItem, Stack, TextField, Typography, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import AsyncButton from "../../components/common/AsyncButton";
import { useNavigate, useParams } from "react-router-dom";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import { useAuth } from "../../contexts/AuthContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";


//TODO: payment page can land from self activation or enroll student activation
const ActivateUser = () => {
    const { user, logout } = useAuth();
    const { id } = useParams();
    const navigate = useNavigate();
    const [userData, setUserData] = useState();
    const [isActivationInProgress, setIsActivationInProgress] = useState(false);

    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    //TODO: Show details
    const getUserData = async () => {
        const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/info`,
            { "ID": id },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true || uinfo["othererror"] == true) {
            return { state: "loggedout" }
        }
        return uinfo.response
    }

    const getActivationStatus = async () => {
        const response = await InvokeAPI(
            `${getUserMgmtBase()}/v1/user/enroll/activation-status`,
            {
                "UserID": id,
            },
            'POST',
            { "authorization": user["token"] },
            false
        )
        if (response["unauthenticated"] == true || response["unauthorized"] == true || response["othererror"] == true) {
            return
        }
        if (response.response && response.response["IsInProgress"] === true) {
            setIsActivationInProgress(true)
        }
    }
    const activateUser = async (userID) => {
        const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enroll/activate`,
            {
                "UserID": userID,
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
            return;
        }

        if (uinfo["othererror"] == true || uinfo["iserror"] == true) {
            setState({ open: true, severity: "error", message: "Unable to initiate activation. Please try again." });
            return;
        }
        
        setState({ open: true, severity: "success", message: "User activation initiated successfully. We will send an email when the account is activated." })
        setTimeout(() => {
            if (id != user["id"]) {
                navigate("/app/enroll")
            } else {
                navigate("/app/practice")
            }
        }, 3600);
    }
    const handleActivate = async (userID) => {
        await activateUser(userID);
    };

    useEffect(() => {
        getUserData().then(data => setUserData(data))
        getActivationStatus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={6000}
                TransitionProps={{ timeout: 300 }}
            >
                <Alert 
                    variant="filled" 
                    severity={state.severity}
                    sx={{
                        animation: 'slideUp 0.3s ease-out',
                        '@keyframes slideUp': {
                            from: {
                                opacity: 0,
                                transform: 'translateY(-20px)',
                            },
                            to: {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    {state.message}
                </Alert>
            </Snackbar>
        <Card
            elevation={6}
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                    transform: 'translateY(-2px)',
                },
            }}
        >
            <CardHeader 
                sx={{ textAlign: 'center', pb: 1 }}
                title={
                    <Typography 
                        sx={{ 
                            fontWeight: 600,
                            fontSize: '1.125rem',
                            color: 'text.primary',
                            letterSpacing: '-0.01em',
                            textAlign: 'center',
                            width: '100%'
                        }} 
                        variant="h6"
                    >
                        User Activation
                    </Typography>
                } 
            />
            <CardContent>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Stack spacing={3} sx={{ width: '100%', maxWidth: '400px' }}>
                        {isActivationInProgress ? (
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                                    Your account activation is in progress, no further action is required from your side. You will receive an email when success.
                                </Typography>
                            </Box>
                        ) : (
                            <>
                                {userData !== undefined &&
                                    <Box>
                                        <Stack spacing={2}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <AccountCircleIcon color="primary" />
                                                <TextField
                                                    label="Username"
                                                    variant="outlined"
                                                    name="username"
                                                    value={userData["Username"]}
                                                    fullWidth
                                                    disabled
                                                />
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <PersonIcon sx={{ color: "black" }} />
                                                <TextField
                                                    label="First Name"
                                                    variant="outlined"
                                                    name="fname"
                                                    value={userData["Fname"]}
                                                    fullWidth
                                                    disabled
                                                />
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <BadgeIcon sx={{ color: "purple" }} />
                                                <TextField
                                                    label="Last Name"
                                                    variant="outlined"
                                                    name="lname"
                                                    value={userData["Lname"]}
                                                    fullWidth
                                                    disabled
                                                />
                                            </Box>
                                        </Stack>
                                    </Box>}
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <AsyncButton
                                        sx={{
                                            textTransform: "initial",
                                            minWidth: '200px',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: (theme) => theme.shadows[8],
                                            },
                                        }}
                                        type="submit"
                                        variant="contained"
                                        color="success"
                                        loadingLabel={<b>Activating...</b>}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            return handleActivate(id);
                                        }}
                                    >
                                        <b>Activate</b>
                                    </AsyncButton>
                                </Box>
                            </>
                        )}
                    </Stack>
                </Box>
            </CardContent>
        </Card>
        </Box>
    );
};

export default ActivateUser;